import {Injectable} from '@angular/core';
import {ApiService} from '../api.service';
import {ApiSmsLayoutHelperService} from './sms-layout-helper.service';
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class ApiSmsLayoutService {
  constructor(public hpr: ApiSmsLayoutHelperService,
              private _api: ApiService) {
  }

  get(id: number | string) {
    return this._api.get('sms-layout/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('sms-layout/list', data);
  }

  create(data: any) {
    return this._api.post('sms-layout/create', data);
  }

  update(data: any) {
    return this._api.post('sms-layout/update', data);
  }

  remove(id: number) {
    return this._api.post('sms-layout/remove/id/' + id);
  }

  autocompleteSource(data = {}) {
    return (text?: string, id?: number) => {
      return this.list(text !== null ? {...data, text} : {ids: Array.isArray(id) ? id : [id]})
        .pipe(map((result) => result.data.map((item: any) => {
          return {
            id: item.id,
            label: item.name,
            data: item
          };
        })));
    };
  }
}
